(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ks-cinematic-collection-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ks-cinematic-hero')) {
    class KsCinematicHero extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.progressBar = this.querySelector('.ks-cinematic-hero__progress-bar');
        this.currentEl = this.querySelector('[data-hero-current]');
        this.prevBtn = this.querySelector('[data-hero-prev]');
        this.nextBtn = this.querySelector('[data-hero-next]');
        this.autoplayMs = parseInt(this.dataset.autoplay, 10) || 0;
        this.currentIndex = 0;
        this.timer = null;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (this.prevBtn) {
          this.prevBtn.addEventListener('click', () => {
            this.goTo((this.currentIndex - 1 + this.slides.length) % this.slides.length);
            this.restartAutoplay();
          });
        }

        if (this.nextBtn) {
          this.nextBtn.addEventListener('click', () => {
            this.goTo((this.currentIndex + 1) % this.slides.length);
            this.restartAutoplay();
          });
        }

        if (this.slides.length < 2 || this.autoplayMs < 1000 || this.reducedMotion) {
          return;
        }

        this.style.setProperty('--ks-hero-duration', this.autoplayMs / 1000 + 's');
        this.addEventListener('mouseenter', () => this.pause());
        this.addEventListener('mouseleave', () => this.play());
        this.addEventListener('focusin', () => this.pause());
        this.addEventListener('focusout', () => this.play());
        this.play();
      }

      disconnectedCallback() {
        this.pause();
      }

      play() {
        this.pause();
        this.classList.add('is-playing');
        if (this.progressBar) {
          this.progressBar.style.animation = 'none';
          void this.progressBar.offsetWidth;
          this.progressBar.style.animation = '';
        }
        this.timer = window.setTimeout(() => {
          this.goTo((this.currentIndex + 1) % this.slides.length);
          this.play();
        }, this.autoplayMs);
      }

      pause() {
        this.classList.remove('is-playing');
        if (this.timer) {
          window.clearTimeout(this.timer);
          this.timer = null;
        }
      }

      goTo(index) {
        this.slides[this.currentIndex].classList.remove('is-active');
        this.currentIndex = index;
        this.slides[this.currentIndex].classList.add('is-active');

        if (this.currentEl) {
          this.currentEl.textContent = this.currentIndex + 1;
        }
      }

      restartAutoplay() {
        if (this.slides.length < 2 || this.autoplayMs < 1000 || this.reducedMotion) {
          return;
        }

        this.play();
      }
    }

    customElements.define('ks-cinematic-hero', KsCinematicHero);
  }

  } catch(e) { console.error(e); }
})();
})();
